// import logo from './assets/logo-white.png'
import logo from './assets/logo-white-bg.svg'

const Header = () => {
    
    const scrollTo = (id) => {
        try{
            document.getElementById(id).scrollIntoView({ 
                behavior: 'smooth',
                block: 'center'
            });
        }
        catch{
            window.location.href = `/#${id}`
        }
    }


    const checkAndRedirect = () => {
        if(window.location.href.split('/')[3].length > 0){
            window.location.href = '/'
        }
        else {
            window.scrollTo(0, 0)
        }
    }

    return ( 
        <div className="header">
            <div className="header-wrapper">
                <img src={logo} alt="" style={{cursor: 'pointer'}} onClick={() => checkAndRedirect()}/>
                <div className="redirects">
                    <h3 onClick={() => checkAndRedirect()}>Início</h3>
                    <h3 onClick={() => scrollTo('apoio')}>Soluções</h3>
                    <h3 onClick={() => scrollTo('sobre')}>Sobre</h3>
                    <h3 onClick={() => scrollTo('funciona')}>Método</h3>
                    <h3 onClick={() => scrollTo('contato')}>Contato</h3>
                    <a href="/salas"><h3>Salas de Apoio</h3></a>
                </div>
                <a href='https://api.whatsapp.com/send?phone=558006761000&text=Olá! Gostaria de agendar uma consulta.' target='_blank' rel='noreferrer' className="button">Fale com um especialista</a>
            </div>
        </div>
     );
}
 
export default Header;